import i18n from '@/i18n';

export const PER_PAGE_OPTIONS = [25, 50, 100];

// A function, not a module-scope const: labels call i18n.t(), so they must be re-evaluated on
// every use (from a computed) to react to a runtime locale switch.
export const getJobFieldDefinitions = () => [
  {
    key: 'job_code',
    label: i18n.t('jobs.fields.jobCode'),
  },
  {
    key: 'hourly_rate',
    label: i18n.t('jobs.fields.hourlyRate'),
    formatter: value => {
      if (value === null || value === undefined || value === '') {
        return '';
      }
      const pounds = value / 100;
      return `${pounds.toFixed(2)}`;
    },
  },
  {
    key: 'multiplier',
    label: i18n.t('jobs.fields.multiplier'),
  },
  {
    key: 'actions',
    label: i18n.t('jobs.fields.actions'),
    thClass: 'text-center',
    tdClass: 'text-center',
  },
];
